import { SxProps, Theme } from '@mui/material';

export interface Show {
  name: string;
  show_image: string;
}

export interface MediaGenre {
  name: string;
  genre_image: string;
  shows: Show[];
}

export interface MediaContent {
  id: string;
  title: string;
  published_at: string;
  thumbnail: string;
  source: string;
  duration_seconds: number;
  type: string;
  platform: string;
  show: string;
  genre: string;
  url: string;
}

export interface UseCarouselProps<T> {
  gap?: number | string;
  items: T[];
  useAnimation: boolean;
}

export interface CarouselProps<T> {
  items: T[];
  renderItem: (item: T, index: number) => React.ReactNode;
  itemHeight?: string;
  showNavigation?: boolean;
  gap?: number | string;
  padding?: number;
  onItemClick?: (item: T, index: number) => void;
  className?: string;
  sx?: any;
  linearGradient?: boolean;
  useAnimation?: boolean;
}

export interface CarouselCardProps {
  title: string;
  imagePath?: string;
  imageUrl?: string;
  isAvailable?: boolean;
  onClick: () => void;
  duration?: number;
  publishedAt?: string;
  showComingSoon?: boolean;
  sx?: SxProps<Theme>;
  variant?: 'mobile' | 'desktop';
  isSelected?: boolean;
  centerText?: boolean;
}

export interface Ticker {
  symbol: string;
  high: string;
  low: string;
  open: string;
  close: string;
  timestamp: string;
}

export interface FreemiumTickersDataResponse {
  [key: string]: Ticker[];
}

export enum NavigationLevel {
  CATEGORIES = 'categories',
  VIDEOS = 'videos',
  SHOWS = 'shows',
  SEARCH = 'search',
}
